<div class="title">
  <div>
    Tekst:
    <span *ngIf="textLabel?.length > 0" class="normal-weight">{{
      textLabel
    }}</span>
  </div>
  <div class="smaller-text italic d-flex">
    <div>(Gepersonaliseerde tekst en/of stedenbouwkundige afkortingen</div>
    <img
      class="house-icon"
      src="/assets/client-ip-board/house-icon.png"
      matTooltip="Klik hier om eventuele gewenste afkortingen aan te passen"
      [matTooltipPosition]="'after'"
      (click)="openAbbreviationSelectorModal()"
    />
    <div>)</div>
  </div>
</div>

<div
  class="text-input"
  [ngClass]="
    showOtherSideField ? 'less-form-field-padding' : 'no-form-field-padding'
  "
>
  <div *ngIf="showOtherSideField || ipBoard.leftRightBoard" class="side-label">
    {{ label }}
  </div>
  <mat-form-field class="textarea-width" appearance="outline">
    <textarea
      matInput
      class="client-textarea textarea-width"
      placeholder="Noteer hier uw gepersonaliseerde tekst (bv.: Gerenoveerde woning met tuin)"
      [(ngModel)]="ipBoardPart.customText"
      (ngModelChange)="customTextChanged()"
      cdkTextareaAutosize
    ></textarea>
  </mat-form-field>
</div>

<div *ngIf="showOtherSideField" class="text-input no-form-field-padding">
  <div class="side-label">Rechts</div>
  <mat-form-field class="textarea-width" appearance="outline">
    <textarea
      matInput
      class="client-textarea textarea-width"
      placeholder="Noteer hier uw gepersonaliseerde tekst (bv.: Gerenoveerde woning met tuin)"
      [(ngModel)]="ipBoardPart.otherCustomText"
      (ngModelChange)="otherCustomTextChanged()"
      cdkTextareaAutosize
    ></textarea>
  </mat-form-field>
</div>

<div
  class="left-fifteen-space"
  *ngIf="
    ipBoardPart.boardType?.ordinal === BOARD_TYPE_CHOICES.V.ordinal &&
    !ipBoard.leftRightBoard
  "
>
  <mat-checkbox
    [(ngModel)]="showOtherSideField"
    (ngModelChange)="showOtherSideFieldChanged()"
    ><span class="smaller-text"
      >Links/Rechts bord afzonderlijk v/e andere tekst voorzien</span
    ></mat-checkbox
  >
</div>
